export function openOrCopyAssessmentLink(assessment, urlsService, utilsService) {
    if (assessment.public_uuid !== null && assessment.public_uuid !== undefined) {
        const url = urlsService.getUrl(urlsService.RTQ.ASYNC_ASSESSMENT, {
            assessmentUUID: assessment.public_uuid,
        });
        utilsService.copyToClipboard(`${process.env.ABSOLUTE_URL}${url}`);
    }
    else {
        const url = urlsService.getUrl(urlsService.RTQ.SAVED_ASSESSMENT, {
            assessmentId: assessment.id,
        });
        window.open(url, '_blank');
    }
}
